import { css } from 'linaria';
import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { SystemsSectionCardStructure } from './systems-section-types';

export const SYSTEMS_SECTION_CARD_LIST: SystemsSectionCardStructure[] = [
  {
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-ventilyacii-i-kondicionirovaniya-pod-klyuch/',
      title: 'Системы вентиляции',
    },
    card: {
      media: {
        alt: 'Вентиляция',
        src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/ventilation-2.jpg/ventilation-2.jpg`,
        title: 'Вентиляция',
      },
      content: {
        title: 'Вентиляция',
        description:
          'От\u00A0бытовых вентиляторов на\u00A0кухне и\u00A0в\u00A0санузлах до\u00A0обеспечения полноценного воздухообмена во\u00A0всём доме с\u00A0помощью приточно-вытяжной установки',
      },
    },
  },
  {
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-vodosnabzheniya-i-kanalizacii-pod-klyuch/',
      title: 'Системы водоснабжения и канализации',
    },
    card: {
      media: {
        alt: 'Водоснабжение',
        src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/sewerage.jpg/sewerage.jpg`,
        title: 'Водоснабжение',
      },
      content: {
        title: 'Водоснабжение',
        description:
          'От\u00A0подбора насосной станции и\u00A0прокладки труб из\u00A0колодца или скважины в\u00A0дом до\u00A0обустройства сантехнического шкафа и\u00A0подведения коммуникаций к\u00A0точкам потребления',
      },
    },
  },
  {
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-filtracii-vody-dlya-zagorodnogo-doma-pod-klyuch/',
      title: 'Системы фильтрации воды для загородного дома',
    },
    card: {
      media: {
        alt: 'Фильтрация воды',
        src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/filter.jpg/filter.jpg`,
        title: 'Фильтрация воды',
      },
      content: {
        title: 'Фильтрация воды',
        description:
          'От\u00A0анализа воды и\u00A0подбора оборудования для загородных домов и\u00A0дачи до\u00A0монтажа и\u00A0сервисного обслуживания. Системы очистки воды от\u00A0неприятных запахов, железа, марганца, солей и\u00A0других примесей',
      },
    },
    cardStyle: css`
      @media (--only-tablet) {
        grid-column: 2;
      }
    `,
  },
  {
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-otopleniya-pod-klyuch/',
      title: 'Системы отопления',
    },
    card: {
      media: {
        alt: 'Отопление',
        src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/2.jpg/2.jpg`,
        title: 'Отопление',
      },
      content: {
        title: 'Отопление',
        description:
          'От\u00A0сварки труб и\u00A0установки радиатора до\u00A0обвязки и\u00A0проведения пусконаладочных работ котельного оборудования',
      },
    },
    cardStyle: css`
      @media (--only-tablet) {
        grid-row: 2;
      }

      @media (--only-mobile) {
        grid-row: 4;
      }
    `,
  },
  {
    link: {
      href: '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-elektrosnabzheniya-pod-klyuch/',
      title: 'Системы электроснабжения',
    },
    card: {
      media: {
        alt: 'Электрика',
        src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/v2-3.jpg/v2-3.jpg`,
        title: 'Электрика',
      },
      content: {
        title: 'Электрика',
        description:
          'От\u00A0прокладки кабеля и\u00A0установки розеток до\u00A0сборки электрических и\u00A0слаботочных щитов',
      },
    },
    cardStyle: css`
      @media (--only-mobile) {
        grid-row: 3;
      }
    `,
  },
];
